import { match } from 'ts-pattern';
import { ProductCode } from '@dev/ee-api/ee-api-models';
import { DashboardPaths } from '@/services/dictionaries/Paths';
import { useSelector } from 'react-redux';
import { getConfigStore } from '@/store/config/actions';
import { useCurrentPlanStatus } from '../useCurrentPlanStatus';

/**
 * Determines productCode based on certain checks
 * 
 * On localhost check is only based on productCode from an account plan
 * @returns ProductCode
 */
export const useConfigProductCode = (): ProductCode => {
    const { isStandalone, routerBasePath } = useSelector(getConfigStore);
    const { productCode } = useCurrentPlanStatus();
    const planProductCode: ProductCode = productCode;
    return match({ isStandalone, routerBasePath, planProductCode })
        .with({ planProductCode: ProductCode.CreatorSuite }, () => ProductCode.CreatorSuite)
        .with({ routerBasePath: DashboardPaths.CreatorSuite, isStandalone: true }, () => ProductCode.CreatorSuite)
        .with({ isStandalone: true, routerBasePath: DashboardPaths.Marketing }, () => ProductCode.Marketing)
        .otherwise(() => ProductCode.Legacy);
};
